@if (incomeTaxEntity$ | async) {
  @if((((incomeTaxEntity$ | async))?.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.leningen?.length ?? 0) < 1) {
    <div>
      Vul eerst een of meer eigenwoningschulden in om de financieringskosten te kunnen invullen.
    </div>
  }
  @else {
    <form [formGroup]="formGroup">
      @if (financieringskosten.length > 0) {
        <div formArrayName="financieringskosten">
          @for (item of financieringskosten.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                <snelstart-ui-select-form-control [label]="i === 0 ? 'Soort kosten' : ''"
                                                  [options]="soortFinancieringskosten"
                                                  class="custom-input-250 col-auto"
                                                  formControlName="omschrijving"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  align="right"
                                                  class="custom-input-150 col-auto"
                                                  formControlName="bedrag"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="deleteRij(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
              </div>
            </div>
          }
        </div>
      }
    </form>
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                         type="link">Kosten toevoegen
    </snelstart-ui-button>
  }
}
